/**
 * Menu icons, ported from the `RenderIcon` helper in the `AuthorizedMenu` view
 * component. Menu rows are configured in the database, so all three of the icon
 * conventions already stored there have to keep working:
 *
 *  - Font Awesome classes  — "fas fa-cogs", "fa-user"
 *  - Bootstrap Icons       — "bi bi-gear", or bare "bi-gear"
 *  - SVG sprite references — "anchor" (resolved against the shared sprite), or
 *                            a full path such as "/myui/icons/sprite.svg#x"
 */

const FONT_AWESOME_PREFIXES = ['fas ', 'far ', 'fab ', 'fal ', 'fad '];

function isFontAwesome(icon: string): boolean {
  return (
    icon.startsWith('fa-') ||
    icon.includes(' fa-') ||
    FONT_AWESOME_PREFIXES.some((prefix) => icon.startsWith(prefix))
  );
}

function isBootstrapIcon(icon: string): boolean {
  return icon.startsWith('bi bi-') || icon.startsWith('bi-');
}

/** "bi-gear" needs the family class too; "bi bi-gear" already has it. */
function normalizeBootstrapIcon(icon: string): string {
  return icon.startsWith('bi-') ? `bi ${icon}` : icon;
}

function spriteHref(icon: string): string {
  if (icon.startsWith('/') || icon.includes('.svg')) return icon;
  return `/myui/icons/sprite.svg#${icon}`;
}

export function NavIcon({ icon }: { icon: string | null }) {
  if (!icon || icon.trim() === '') return null;

  const trimmed = icon.trim();

  if (isBootstrapIcon(trimmed)) {
    return <i className={normalizeBootstrapIcon(trimmed)} />;
  }

  if (isFontAwesome(trimmed)) {
    return <i className={trimmed} />;
  }

  return (
    <svg className="sa-icon">
      <use href={spriteHref(trimmed)} />
    </svg>
  );
}
